import { matchesFolderScope } from '../api/folderApi';

export function sortFolders(folders = []) {
    return [...folders].sort((a, b) => {
        const sortDelta = (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
        if (sortDelta !== 0) return sortDelta;
        return (a.name ?? '').localeCompare(b.name ?? '', 'tr');
    });
}

export function filterFoldersByScope(scope, folders = []) {
    return sortFolders(folders.filter((folder) => matchesFolderScope(folder.scope, scope)));
}

export function getNextFolderSortOrder(folders = [], parentFolderId = null) {
    return folders.filter((folder) => (folder.parentFolderId ?? null) === (parentFolderId ?? null)).length + 1;
}


